import Mock from 'mockjs'

const {page, save} = require('../util');
const {companies} = require('./data');
const qs = require('qs');

Mock.mock('/company/findAll', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    bodyObject.data = page(companies, bodyObject);
    bodyObject.total = companies.length;
    return {
        code: 200,
        body: bodyObject,
    }
});

Mock.mock('/company/save', 'post', ({url, type, body}) => {
    let bodyObject = qs.parse(body);
    console.log('mock请求 url: %s, body: %o', url, bodyObject);
    save(bodyObject, companies);
    return {
        code: 200,
        body: companies,
    }
});
